var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "wrap-billet-content" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "small-12 medium-12 large-12 medium-centered columns" },
        [
          _c("h2", [_vm._v("Olá " + _vm._s(_vm.nome) + ",")]),
          _vm._v(" "),
          _c("p", [_vm._v("Seguem os boletos disponíveis em nosso sitema.")]),
          _vm._v(" "),
          _c("table", [
            _c(
              "tbody",
              [
                _c("tr", [
                  _c("th", { staticStyle: { width: "50%" } }, [_vm._v("Nome")]),
                  _vm._v(" "),
                  _c("th", { staticStyle: { width: "50%" } }, [
                    _vm._v("Endereço")
                  ]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Vencimento")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Valor")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Mês/Ano")]),
                  _vm._v(" "),
                  _c("th"),
                  _vm._v(" "),
                  _c("th"),
                  _vm._v(" "),
                  _vm.banner_popup != "" ? _c("th") : _vm._e(),
                  _vm._v(" "),
                  _vm.popup_simulacao == 1 ? _c("th") : _vm._e()
                ]),
                _vm._v(" "),
                _vm._l(_vm.boletos, function(boleto) {
                  return _c("SearchResultItem", {
                    key: boleto.codigo,
                    attrs: {
                      popup_simulacao: _vm.popup_simulacao,
                      banner_popup: _vm.banner_popup,
                      boleto: boleto
                    },
                    on: { atualizarVencimento: _vm.atualizarVencimento }
                  })
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _vm._m(0)
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("i", [
        _vm._v(
          "\n                    Caso esta seja a SEGUNDA VIA do seu boleto é necessário que após a geração do mesmo você aguarde uma hora para efetuar o pagamento,\n                    pois o boleto precisa ser registrado junto ao banco.\n                "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }